<template>
  <div class="student-dialog">
    <el-dialog
      title="查看学员"
      width="1000px"
      :visible.sync="dialogVisible"
      :before-close="handleClose">
      <el-form :inline="true" :model="filter" size="small">
        <el-form-item label="手机号：">
          <el-input v-model="filter.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="添加时间：">
          <el-date-picker
            v-model="date1"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row class="operate-line">
        <el-button type="primary" size="small" @click="addStudent">添加学员</el-button>
        <el-button type="primary" size="small" @click="into">导入</el-button>
        <el-button type="text" size="small" @click="downloadTemplate">下载导入模板</el-button>
      </el-row>
      <el-card style="margin-top: 10px;">
        <el-table ref="table" v-loading="loading" :data="list" border style="margin-top: 10px">
          <el-table-column align="center" label="学员姓名" prop="name" width="180px" />
          <el-table-column align="center" label="学员手机号" prop="phone" />
          <el-table-column align="center" label="支付宝账号" prop="zfbAccount" />
          <el-table-column align="center" label="加入时间" prop="insertDate" />
          <el-table-column align="center" label="操作" prop="" width="160" fixed="right">
            <template v-slot="{ row }">
              <el-button type="text" class="operate-button" @click="handleEdit(row)">编辑</el-button>
              <el-popconfirm
                title="确认删除当前学员吗？"
                @confirm="handleDelete(row.id)"
              >
                <el-button slot="reference" type="text" class="operate-button">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </el-card>
    </el-dialog>
    <!-- 添加学员 -->
    <el-dialog
      :title="`${addForm.id ? '编辑' : '添加'}学员`"
      width="480px"
      :visible.sync="addVisible"
      :before-close="handleCloseAdd"
    >
      <el-form
        ref="addFormEl"
        :model="addForm"
        :rules="rules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="学员手机号：" prop="phone">
          <el-input type="tel" v-model="addForm.phone" maxlength="11" placeholder="请输入学员手机号" />
        </el-form-item>
        <el-form-item label="学员姓名：">
          <el-input v-model="addForm.name" maxlength="16" placeholder="请输入学员姓名" />
        </el-form-item>
        <el-form-item label="支付宝账号：" prop="zfbAccount">
          <el-input v-model="addForm.zfbAccount" maxlength="100" placeholder="请输入支付宝账号" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="" size="small" @click="handleCloseAdd">取消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit(false)">保存</el-button>
      </span>
    </el-dialog>

    <input
      ref="uploadEl"
      type="file"
      name="uploadFile"
      style="display: none"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
      @change="handleUpload"
    >
  </div>
</template>

<script>
import {
  getStudentListPage,
  downloadTemplate,
  importUser,
  getCountByPhone,
  editActivityMediaSaleUser,
  delActivityMediaSaleUser
} from '@/api/admin/bootcamp.js'

export default {
  name: 'StudentDialog',

  data() {
     const validatePhone = (rule, value, callback) => {
      if (!/^1\d{10}$/.test(value)) {
        callback(new Error('请填写正确的手机号码'))
      } else {
        callback()
      }
    }
     const validateAccount = (rule, value, callback) => {
      if (
        value &&
        !/^1\d{10}$/.test(value) &&
        !/^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/.test(value)
      ) {
        callback(new Error('请填写正确的支付宝账号'))
      } else {
        callback()
      }
    }
    return {
      id: '',
      dialogVisible: false,
      loading: false,
      filter: {
        page: 1,
        limit: 10,
        phone: '',
        startDate: '',
        endDate: '',
      },
      total: 0,
      list: [],
      // 编辑学员
      addVisible: false,
      addForm: {
        phone: '',
        name: '',
        zfbAccount: ''
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' },
        ],
        zfbAccount: [
          { validator: validateAccount, trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
    date1: {
      get() {
        return [this.filter.startDate, this.filter.endDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.startDate = v[0] + ' 00:00:00' || ''
          this.filter.endDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.startDate = ''
          this.filter.endDate = ''
        }
      }
    }
  },
  methods: {
    init(id) {
      this.id = id
      this.getList()
      this.dialogVisible = true
    },
    getList (refresh = true) {
      this.loading = refresh
      const params = {
        saleId: this.id,
        ...this.filter
      }
      getStudentListPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.total = Number(data.total)
          if (this.filter.page === 1) {
            this.$nextTick(() => {
              this.$refs.table.doLayout()
            })
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      const d = this.$options.data()
      this.filter = d.filter
      this.total = 0
      this.list = []
      this.getList()
    },
    addStudent() {
      this.addVisible = true
    },
    into() {
      this.$refs.uploadEl.value = ''
      this.$refs.uploadEl.click()
    },
    // 上传文件
    handleUpload({ target }) {
      if (target.files && target.files.length !== 0) {
        const form = new FormData()
        form.append('file', target.files[0])
        form.append('saleId', this.id)
        importUser(form).then(({ code }) => {
          if (code === 0) {
            this.$message.success('导入成功!')
            this.getList(false)
          }
        })
      }
    },
    downloadTemplate() {
      downloadTemplate()
    },
    handleEdit({ id, phone, name, zfbAccount }) {
      this.addForm = { id, phone, name, zfbAccount }
      this.addVisible = true
    },
    handleDelete(id) {
      delActivityMediaSaleUser({ id }).then(({ code }) => {
        if (code === 0) {
          this.$message.success('删除成功!')
          this.getList(false)
        }
      })
    },
    handleSubmit(confrim = false) {
      this.$refs.addFormEl.validate(async valid => {
        if (valid) {
          if (this.addForm.phone.length !== 11) {
            this.$message.warning('请输入正确手机号码!')
            return
          }
          if (!confrim) {
            const { data } = await getCountByPhone({
              phone: this.addForm.phone,
              id: this.addForm.id
            })
            if (data !== 0) {
              this.$confirm('该学员已关联销售账号，关联当前销售后，学员将解除原关系，确认操作吗？', '确认信息', {
                confirmButtonText: '确认',
                cancelButtonText: '取消'
              })
                .then(() => {
                  this.handleSubmit(true)
                })
              return
            }
          }
          const params = {
            saleId: this.id,
            ...this.addForm
          }
          editActivityMediaSaleUser(params).then(({ code, data }) => {
            if (code === 0) {
              this.$message.success(`${this.addForm.id ? '编辑' : '添加'}成功!`)
              this.getList(false)
              this.handleCloseAdd()
            }
          })
        }
      })
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleClose() {
      const d = this.$options.data()
      this.filter = d.filter
      this.total = 0
      this.list = []
      this.dialogVisible = false
    },
    handleCloseAdd() {
      const d = this.$options.data()
      this.addForm = d.addForm
      this.addVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.operate-button {
  margin-right: 10px;
  padding: 0;
}
</style>
